import { render, staticRenderFns } from "./secretKeyForm.vue?vue&type=template&id=445f0b10&scoped=true&"
import script from "./secretKeyForm.vue?vue&type=script&lang=js&"
export * from "./secretKeyForm.vue?vue&type=script&lang=js&"
import style1 from "./secretKeyForm.vue?vue&type=style&index=1&id=445f0b10&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445f0b10",
  null
  
)

export default component.exports